export default __webpack_public_path__ + "904ee4b.png";